"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseSpinner = void 0;
var core_1 = require("@material-ui/core");
var styled_components_1 = __importDefault(require("styled-components"));
exports.BaseSpinner = styled_components_1.default(core_1.CircularProgress).attrs(function (_a) {
    var theme = _a.theme;
    return ({ size: theme.vui.component.spinner.size });
}).withConfig({ displayName: "BaseSpinner", componentId: "sc-u5apc0" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["color:", ";"], ["", ""])), function (_a) {
    var theme = _a.theme;
    return theme.vui.component.spinner.color;
});
var templateObject_1;
